/**
 * 命令执行失败时抛出的统一错误对象
 */
class CommandError extends Error {
  constructor({ message, code, action, requestId, data, meta, payload, raw }) {
    super(message ?? `命令 ${action ?? '未知'} 执行失败`)
    this.name = 'CommandError'
    this.code = code
    this.action = action
    this.requestId = requestId
    this.data = data
    this.meta = meta
    this.payload = payload
    this.raw = raw
  }
}

class CommondResultError extends Error {
  constructor(raw) {
    const { message, code, action, requestId, data, meta, payload } = raw
    super(message)
    this.name = 'CommondResultError'
    this.code = code
    this.action = action
    this.requestId = requestId
    this.data = data
    this.meta = meta
    this.payload = payload
    this.raw = raw
  }
}

export { CommandError, CommondResultError }
